import LicenseRequestFormPriceTiers from './licenseRequestFormPriceTiers'

class LicenseRequestFormSettings {
  constructor(data) {
    this.currencyId = data.cid;
    this.currency = data.c;
    this.licensePriceTiers = data.lpt ? data.lpt.map(
      (x) => new LicenseRequestFormPriceTiers(x),
    ) : [];
  }
}

export default LicenseRequestFormSettings

